import { LoadingIndicator } from '@shared/ui';
const FullScreenLoader = () => <div className="flex-center w-full min-h-screen" data-sentry-component="FullScreenLoader" data-sentry-source-file="index.tsx">
    <LoadingIndicator size="lg" color="primary" center className="min-h-48" data-sentry-element="LoadingIndicator" data-sentry-source-file="index.tsx" />
  </div>;
export default FullScreenLoader;